import { render } from "./WidgetBmfwfLinkanzeige.vue?vue&type=template&id=09d50486&scoped=true&ts=true"
import script from "./WidgetBmfwfLinkanzeige.vue?vue&type=script&lang=ts"
export * from "./WidgetBmfwfLinkanzeige.vue?vue&type=script&lang=ts"

import "./WidgetBmfwfLinkanzeige.vue?vue&type=style&index=0&id=09d50486&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d50486"]])

export default __exports__